import styled, { createGlobalStyle } from "styled-components"

export const StyledLayout = styled.main`
  min-height: 60vh;
  margin-left: auto;
  margin-right: auto;
  max-width: 50rem;
  padding: 2rem 1.5rem;
  text-align: justify;
`

export const GlobalStyle = createGlobalStyle`
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  html {
    text-rendering: optimizeLegibility;
    overflow-x: hidden;
    box-sizing: border-box;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  html,
  body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background: #222;
    color: #fff;
  }

  #___gatsby {
    height: 100%;
  }

  div[role="group"][tabindex] {
    height: 100%;
  }

  body {
    display: flex;
    flex-direction: column;
  }
  ::selection {
    background: #000;
    color: #00c853;
  }
  a {
    color: #fff;
    transition: color 0.1s;
  }
  a:hover {
    color: #00c853;
  }
  h1 {
    font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }
  .headroom-wrapper {
    position: fixed;
    width: 100%;
    z-index: 2000;
    top: 0;
  }
  .headroom {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    padding: 1rem;
    svg {
      height: 2.5rem;
      g {
        fill: #fff;
      }
    }
  }
  .headroom--unfixed {
    position: relative;
    transform: translateY(0);
    transition: all 0.25s ease-in-out;
  }
  .headroom--scrolled {
    transition: all 0.25s ease-in-out;
  }
  .headroom--unpinned {
    position: fixed;
    transform: translateY(-100%);
    transition: all 0.25s ease-in-out;
  }
  .headroom--pinned {
    position: fixed;
    transform: translateY(0);
    transition: all 0.25s ease-in-out;
    background: linear-gradient(45deg, #00c853 0%, #00c853 100%);
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.2);
    nav {
      a {
        background-color: #222;
        border-radius: 20px;
        color: #fff;
        &:hover {
          color: #00c853;
        }
        &:focus {
          color: #00c853;
        }
      }
    }
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    svg {
      height: 2.5rem;
      g {
        fill: #fff;
      }
    }
    span {
      color: #fff;
    }
  }
`
